module.exports = __webpack_public_path__ + "static/media/tvShows-back.b5367faa.svg";